import {useContext} from 'react';

import {SearchFormContext} from '../contexts';

function useSearchFormContext() {
    return useContext(SearchFormContext);
}

export {useSearchFormContext};
